{
  "version": 1,
  "asset_id": "9968e16e-a7c7-449b-af82-fd3b1649d77a",
  "project_id": "f1464d76-0c0c-4c5d-aa83-fb0ef36e9a24",
  "url": "/__l5e/assets-v1/9968e16e-a7c7-449b-af82-fd3b1649d77a/salonturbo-logo.png",
  "r2_key": "a/v1/f1464d76-0c0c-4c5d-aa83-fb0ef36e9a24/9968e16e-a7c7-449b-af82-fd3b1649d77a/salonturbo-logo.png",
  "original_filename": "salonturbo-logo.png",
  "size": 51692,
  "content_type": "image/png",
  "created_at": "2026-08-31T20:38:01Z"
}
